import { Component, DOCUMENT, inject } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { AuthService } from './core/auth/auth.service';
import { BUILD, versionLabel } from './core/build-info';
import { FILE_ENCRYPTION_ENABLED } from './core/features';
import { BackgroundWork } from './core/work/background-work';
import { Icon } from './shared/ui/icon/icon';

@Component({
  imports: [RouterOutlet, RouterLink, RouterLinkActive, Icon],
  selector: 'app-root',
  templateUrl: './app.html',
})
export class App {
  protected readonly auth = inject(AuthService);
  private readonly router = inject(Router);
  private readonly work = inject(BackgroundWork);
  private readonly window = inject(DOCUMENT).defaultView;
  protected readonly encryptionAvailable = FILE_ENCRYPTION_ENABLED;
  protected readonly version = versionLabel();
  protected readonly builtAt = BUILD.builtAt && `Built ${new Date(BUILD.builtAt).toLocaleString()}`;

  protected async signOut() {
    // Signing out stops the uploads and encryption still running in this page.
    if (
      this.work.busy() &&
      this.window?.confirm(
        'Files are still being imported or encrypted. Signing out now stops them; unfinished files can be added again later. Sign out anyway?',
      ) === false
    )
      return;
    await this.auth.signOut();
    await this.router.navigateByUrl('/login');
  }
}
